/**
 * @license
 * Copyright Filip Seman
 * SPDX-License-Identifier: MIT
 */
import { LZMA, } from "./lzma.js";
export { LZMA } from "./lzma.js";
export { CRC32_TABLE } from "./utils.js";
/**
 * Compresses data using LZMA algorithm
 *
 * @param data Data to compress - can be Uint8Array or ArrayBuffer
 * @param mode Compression mode (1-9), defaults to 5
 * @returns Compressed data as a byte array
 */
export function compress(data, mode = 5) {
    // Convert ArrayBuffer to Uint8Array if needed
    const input = data instanceof ArrayBuffer
        ? new Uint8Array(data)
        : data;
    const result = new LZMA().compress(input, mode);
    return new Uint8Array(result);
}
/**
 * Compresses data using LZMA algorithm
 *
 * @param data String to compress
 * @param mode Compression mode (1-9), defaults to 5
 * @returns Compressed data as byte array
 */
export function compressString(data, mode = 5) {
    const compressedData = new LZMA().compressString(data, mode);
    return new Uint8Array(compressedData);
}
/**
 * Decompresses LZMA compressed data
 *
 * @param data Compressed data as Uint8Array or ArrayBuffer
 * @returns Decompressed data
 */
export function decompress(data) {
    const input = data instanceof ArrayBuffer
        ? new Uint8Array(data)
        : data;
    const decompressedData = new LZMA().decompress(input);
    return new Uint8Array(decompressedData);
}
/**
 * Decompresses LZMA compressed data
 *
 * @param data Compressed data as Uint8Array or ArrayBuffer
 * @returns Decompressed data as string
 */
export function decompressString(data) {
    return new LZMA().decompressString(data);
}
